export class ListDocumentRequest {
    tableName: string;
    recordId: number;

    constructor(tableName, recordId) {
        this.tableName = tableName;
        this.recordId = recordId;
    }
}
